
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/festivals/[festivalId]/info",
      function () {
        return require("private-next-pages/festivals/[festivalId]/info.tsx");
      }
    ]);
  